import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2bdadcfa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2bdadcfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdadcfa",
  null
  
)

/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=el-dialog&title=%E7%A1%AE%E8%AE%A4%E6%89%93%E6%AC%BE%E5%AE%8C%E6%88%90&%3Avisible.sync=confirmPaymentDialogVisible&width=500px&center=true"
if (typeof block0 === 'function') block0(component)

export default component.exports